import React from "react";
import Owner1 from "./Owner1";
import Owner2 from "./Owner2";
import FilterContext from "../../routes/FilterContext";
import { connect } from "react-redux";
import Owner3 from "./Owner3";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class OwnerContainer extends React.Component {
  static contextType = FilterContext;
  state = {
    filters: "{}",
    mounted: false,
  };

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.setState({ filters: filters, mounted: true });
  }

  componentDidUpdate() {
    if (this.state.filters !== JSON.stringify(this.props.filters)) {
      this.setState({ filters: JSON.stringify(this.props.filters) });
    }
  }

  renderAsset() {
    if (this.state.mounted == true) {
      var filters = JSON.parse(this.state.filters);
      if (filters.owners === undefined || filters.owners.length === 0) {
        return <Owner2 />;
      } else if (filters.owners.length === 1) {
        return <Owner1 />;
      } else {
        return <Owner3 />;
      }
    }
    return <></>;
  }

  render() {
    if (this.state.filters !== undefined) {
      return this.renderAsset();
    } else {
      return <>Loading</>;
    }
  }
}

export default connect(mapStateToProps)(OwnerContainer);
